"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  BREAKPOINTS: () => BREAKPOINTS,
  DevicesProvider: () => DevicesProvider,
  FitText: () => FitText,
  useDevices: () => useDevices,
  useFitText: () => useFitText
});
module.exports = __toCommonJS(src_exports);

// src/useDevices.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var BREAKPOINTS = {
  /** Menor a 480px: celulares en portrait y widgets angostos. */
  compactMax: 480,
  /** De 480px a 1024px: tablets y widgets grandes. */
  tabletMax: 1024
};
var DevicesContext = (0, import_react.createContext)(void 0);
function readViewport() {
  return { width: window.innerWidth, height: window.innerHeight };
}
function DevicesProvider({ children }) {
  const [viewport, setViewport] = (0, import_react.useState)(readViewport);
  (0, import_react.useEffect)(() => {
    function checkDeviceType() {
      setViewport(readViewport());
    }
    checkDeviceType();
    window.addEventListener("orientationchange", checkDeviceType);
    window.addEventListener("resize", checkDeviceType);
    return () => {
      window.removeEventListener("orientationchange", checkDeviceType);
      window.removeEventListener("resize", checkDeviceType);
    };
  }, []);
  const value = (0, import_react.useMemo)(() => {
    const { width, height } = viewport;
    return {
      isDesktop: width > height,
      width,
      height,
      isCompact: width < BREAKPOINTS.compactMax,
      isTablet: width >= BREAKPOINTS.compactMax && width < BREAKPOINTS.tabletMax,
      isWide: width >= BREAKPOINTS.tabletMax
    };
  }, [viewport]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DevicesContext.Provider, { value, children });
}
var useDevices = () => {
  const context = (0, import_react.useContext)(DevicesContext);
  if (!context) {
    throw new Error("useDevices debe ser usado dentro de un DevicesProvider");
  }
  return context;
};

// src/FitText.tsx
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
function useFitText({
  min = 9,
  max,
  step = 0.5,
  allowWrapFallback = true
} = {}) {
  const ref = (0, import_react2.useRef)(null);
  (0, import_react2.useLayoutEffect)(() => {
    const el = ref.current;
    if (!el) return void 0;
    const fits = () => el.scrollWidth <= el.clientWidth + 1;
    const fit = () => {
      el.style.fontSize = "";
      el.style.whiteSpace = "nowrap";
      el.style.overflowWrap = "";
      const natural = parseFloat(window.getComputedStyle(el).fontSize);
      if (!Number.isFinite(natural) || natural <= 0) return;
      let size = typeof max === "number" ? Math.min(natural, max) : natural;
      el.style.fontSize = `${size}px`;
      while (size > min && !fits()) {
        size = Math.max(min, size - step);
        el.style.fontSize = `${size}px`;
      }
      if (!fits() && allowWrapFallback) {
        el.style.whiteSpace = "normal";
        el.style.overflowWrap = "anywhere";
      }
    };
    fit();
    let resizeObserver = null;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(fit);
      resizeObserver.observe(el);
      if (el.parentElement) resizeObserver.observe(el.parentElement);
    }
    const mutationObserver = new MutationObserver(fit);
    mutationObserver.observe(el, { childList: true, characterData: true, subtree: true });
    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [min, max, step, allowWrapFallback]);
  return ref;
}
function FitText(_a) {
  var _b = _a, {
    children,
    min,
    max,
    step,
    allowWrapFallback,
    style
  } = _b, rest = __objRest(_b, [
    "children",
    "min",
    "max",
    "step",
    "allowWrapFallback",
    "style"
  ]);
  const ref = useFitText({
    min,
    max,
    step,
    allowWrapFallback
  });
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "span",
    __spreadProps(__spreadValues({
      ref,
      style: __spreadValues(__spreadValues({
        display: "inline-block",
        maxWidth: "100%",
        whiteSpace: "nowrap"
      }, allowWrapFallback === false ? { overflow: "hidden", textOverflow: "ellipsis" } : {}), style)
    }, rest), {
      children
    })
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BREAKPOINTS,
  DevicesProvider,
  FitText,
  useDevices,
  useFitText
});
